import React, { useState, useEffect } from "react";
// eslint-disable-next-line
import { useParams, Link, Route, Routes, useLocation } from "react-router-dom";
import axios from "axios";

import { Tooltip as ReactTooltip } from "react-tooltip";

import { firebase } from "../Firebase/config";
// eslint-disable-next-line
import { doc, getDoc, updateDoc, arrayUnion } from "@firebase/firestore";
import NavBar from "./Navbar";

import Classes from "./Mapofclassroom/Mapofclassroom";


import "./Messages.css";

function App(hello, studentidd) {
  // eslint-disable-line no-unused-vars

  const location = useLocation();
  const importedObject = location.state?.objectofclass;
  const isClassroomPage = location.pathname.includes("Classroom");


  // eslint-disable-next-line
  const { only2studentid, studentid, classid, language, id, role } = useParams();



  //with teacher access

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //without teacher access

  //   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en


  const [studentidlocal, setstudentidlocal] = useState();

  const [parentemail, setParentemail] = useState();
  const [parentemailbefore, setParentemailbefore] = useState();
  // eslint-disable-next-line
  const [newnumber2, setNewnumber2] = useState("");

  const [newnumber3, setNewnumber3] = useState();

  const [parentphonenumber, setParentphonenumber] = useState();
  const [parentphonenumberbefore, setParentphonenumberbefore] = useState();
  // eslint-disable-next-line
  const [newnumber, setNewnumber] = useState("");

  const [teacher, setTeacher] = useState();
  const [classs, setClasss] = useState();
  const [student, setStudent] = useState();
  const [viewparentpage, setViewparentpage] = useState(true);

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen3b, setIsOpen3b] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen5b, setIsOpen5b] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);

  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);
  const [isOpen17, setIsOpen17] = useState(false);

  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);

  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);

  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);

  const [isOpen24, setIsOpen24] = useState(false);
  const [isOpen25, setIsOpen25] = useState(false);

  const [gradereceived, setGradeReceived] = useState();
  const [nameinobject, setnameinobject] = useState();

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");

  const [viewteachersection, setViewteachersection] = useState(false);

  const [viewteachersection2, setViewteachersection2] = useState();

  const [listofclasses, setListofclasses] = useState();

  const [newwidth, setNewwidth] = useState();
  const [showreminder, setShowreminder] = useState();

  const [gc1compare, setGc1compare] = useState();
  const [gc1datasent, setGc1datasent] = useState([]);
  const [gc1timesent, setGc1timesent] = useState();
  const [gc1title, setGc1title] = useState();
  const [gc1assignmentMaterials, setGc1assignmentMaterials] = useState();
  const [gccompare, setGccompare] = useState();
  const [gcdatasent, setGcdatasent] = useState([]);
  const [gctimesent, setGctimesent] = useState();

  const [selectedclass, setSelectedclass] = useState();
  const [selectedclass1, setSelectedclass1] = useState();

  const [highscore, setHighscore] = useState();
  const [lowscore, setLowscore] = useState();

  const [showpersonal, setShowpersonal] = useState(true);
  const [bringinmenu2, setBringinmenu2] = useState(false);

  const [googleclassroomid, setGoogleclassroomid] = useState();
  const [averageofgrades, setAverageofgrades] = useState();
  const [averageofgradeswithzeros, setAverageofgradeswithzeros] = useState();

  const [getsyllabus, setgetsyllabus] = useState();

  const [sid, setSid] = useState();



  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page.
  const [donotshow, setDonotshow] = useState();
  console.log(language, "THI SIS IS THE LANGUSAST");

  useEffect(() => {
    if (typeof language != "undefined" && language != "en") {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
    }
  }, [language]);



  useEffect(() => {
    setDonotshow(false);
  }, []);

  const getnewlanguaage0 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Grades For",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText0(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage1 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Class",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText1(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage2 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "The emails and phone numbers that",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText2(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage3 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "has to message you are listed below. Please leave only the numbers or email addresses if it is there where you would like to receive messages.",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText3(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage4 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Please delete the rest by pressing",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText4(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage5 = async () => {
    console.log(language, "2 the languge code");
    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Add any additional phone number or email address if it is there where you would also like to receive messages.",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText5(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage6 = async () => {
    console.log(language, "2 the languge code");
    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Submit this Phone Number",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText6(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage7 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "Submit this new Email",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText7(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getnewlanguaage8 = async () => {
    console.log(language, "2 the languge code");

    try {
      const response = await axios.post(
        `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
        {
          source: "en",
          format: "text",
          q: "New Email/Phone #",
          target: language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setText8(response.data.data.translations[0].translatedText);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");
      let googleclassroomid = localStorage.getItem("gclassroomid");
      console.log(googleclassroomid, "this is the googleclassroomid");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
      setGoogleclassroomid(googleclassroomid);
    }

    if (typeof studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");
      let googleclassroomid = localStorage.getItem("gclassroomid");
      console.log(googleclassroomid, "this is the googleclassroomid");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
      setnameinobject(stud);
      setGoogleclassroomid(googleclassroomid);
    }
  }, [only2studentid, studentid]);


  useEffect(() => {
    if (typeof googleclassroomid != "undefined") {
      console.log(googleclassroomid, "this is the googleclassroomid");
    }
  }, [googleclassroomid]);



  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid);
    }
  }, [only2studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid);
    }
  }, [studentid]);

  useEffect(() => {
    // Only run on initial mount








    if (importedObject) {
      console.log("Plan A is going to be run");
      setGc1compare(importedObject.gc1compare);
      setGc1timesent(importedObject.gc1timesent);
      setGc1title(importedObject.gc1title);
      setGccompare(importedObject.gccompare);
      setGctimesent(importedObject.gctimesent);

      // Accept arrays only; fall back to empty arrays
      setGc1datasent(Array.isArray(importedObject.gc1datasent) ? importedObject.gc1datasent : []);
      setGcdatasent(Array.isArray(importedObject.gcdatasent) ? importedObject.gcdatasent : []);

      // Compute scores/averages defensively
      if (Array.isArray(importedObject.gc1datasent)) {
        const grades = importedObject.gc1datasent
          .map(i => (i && typeof i.grade === "number" ? i.grade : null))
          .filter(g => g !== null);

        if (grades.length > 0) {
          setHighscore(Math.max(...grades));
          const gradesAboveZero = grades.filter(g => g > 0);
          setLowscore(gradesAboveZero.length > 0 ? Math.min(...gradesAboveZero) : undefined);
          setAverageofgradeswithzeros(grades.reduce((a, b) => a + b, 0) / grades.length);
          const gradesNoZero = grades.filter(g => g !== 0);
          setAverageofgrades(gradesNoZero.length > 0 ? gradesNoZero.reduce((a, b) => a + b, 0) / gradesNoZero.length : undefined);
        } else {
          setHighscore(undefined);
          setLowscore(undefined);
          setAverageofgradeswithzeros(undefined);
          setAverageofgrades(undefined);
        }

        importedObject.gc1datasent.forEach(item => {
          if (item && item.id === googleclassroomid) {
            setSelectedclass1(item);
            setGradeReceived(item.grade);
          }
        });
      }

      if (Array.isArray(importedObject.gcdatasent)) {
        importedObject.gcdatasent.forEach(item => {
          if (
            item?.profile &&
            (item.profile.firebasestudentid === googleclassroomid ||
              item.profile.firebasestudentid === only2studentid ||
              item.profile.firebasestudentid === studentid)
          ) {
            setSelectedclass(item);
          }
        });
      }
    
    }
    // Only run once on mount
  }, []);

  useEffect(() => {
    // If any critical value is still undefined, fetch from Firebase
    if (
      !gc1datasent ||
      !gcdatasent ||
      !gc1compare ||
      !gccompare ||
      !gradereceived

    ) {
      console.log("the back up plan is going to be run");
      if (typeof classid !== "undefined") {

        seeifpersonexists();
      }
    }
  }, [gc1datasent, gcdatasent, gc1compare, gccompare, classid, gradereceived, googleclassroomid]);




  async function seeifpersonexists() {











    const docRef = doc(firebase, "classesbeingtaught", classid);
    const docData = await getDoc(docRef)
      .then(async (userRec) => {
        const object = userRec.data() || {};

        setGc1compare(object.gc1compare);
        setGc1timesent(object.gc1timesent);
        setGc1title(object.gc1title);
        setGc1assignmentMaterials(object.gc1assignmentMaterials);
        setgetsyllabus(typeof object.syllabus !== "undefined" ? object.syllabus : "");
        setGccompare(object.gccompare);

        // Use safe arrays
        const safeGc1 = Array.isArray(object.gc1datasent) ? [...object.gc1datasent] : [];
        const safeGc = Array.isArray(object.gcdatasent) ? [...object.gcdatasent] : [];

        if (Array.isArray(safeGc1)) {
          safeGc1.sort((a, b) => {
            const gradeA = a?.grade ?? Number.NEGATIVE_INFINITY;
            const gradeB = b?.grade ?? Number.NEGATIVE_INFINITY;
            return gradeB - gradeA;
          });
        }
        setGc1datasent(safeGc1);

        // Compute stats defensively
        if (Array.isArray(safeGc1) && safeGc1.length > 0) {
          const grades = safeGc1.map(i => (i && typeof i.grade === "number" ? i.grade : null)).filter(g => g !== null);
          if (grades.length > 0) {
            setHighscore(Math.max(...grades));
            const gradesAboveZero = grades.filter(g => g > 0);
            setLowscore(gradesAboveZero.length > 0 ? Math.min(...gradesAboveZero) : undefined);
            setAverageofgradeswithzeros(grades.reduce((a, b) => a + b, 0) / grades.length);
            const gradesNoZero = grades.filter(g => g !== 0);
            setAverageofgrades(gradesNoZero.length > 0 ? gradesNoZero.reduce((a, b) => a + b, 0) / gradesNoZero.length : undefined);
          } else {
            setHighscore(undefined);
            setLowscore(undefined);
            setAverageofgradeswithzeros(undefined);
            setAverageofgrades(undefined);
          }

          safeGc1.forEach(item => {
            if (item && item.id === googleclassroomid) {
              setSelectedclass1(item);
              setGradeReceived(item.grade);
            }
          });
        }


        // Sort gcdatasent safely
        if (Array.isArray(safeGc)) {
          safeGc.sort((a, b) => {
            const gradeA = a?.summary?.averageGrade ?? Number.NEGATIVE_INFINITY;
            const gradeB = b?.summary?.averageGrade ?? Number.NEGATIVE_INFINITY;
            return gradeB - gradeA;
          });
        }
        setGcdatasent(safeGc);

        if (Array.isArray(safeGc) && safeGc.length > 0) {
          safeGc.forEach(item => {
            if (
              item?.profile &&
              (item.profile.firebasestudentid === googleclassroomid ||
                item.profile.firebasestudentid === only2studentid ||
                item.profile.firebasestudentid === studentid)
            ) {
              setSelectedclass(item);
            }
          });
        }

        setGctimesent(object.gctimesent);

        console.log(object.gc1compare, safeGc1, object.gc1timesent, object.gccompare, safeGc, object.gctimesent);
      })
      .catch((error) => {
        console.error("seeifpersonexists error:", error);
      });
  }

  useEffect(() => {
    if (typeof gradereceived != "undefined") {
      console.log(gradereceived, nameinobject, "This is the item and grade in object");
    }
  }, [gradereceived, nameinobject]);

  useEffect(() => {
    if (
      typeof studentidlocal != "undefined" &&
      typeof parentphonenumber != "undefined"
    ) {
      console.log("in the final area");
      updatephonenumbberindatabase();
    }
  }, [parentphonenumber]);

  useEffect(() => {
    if (
      typeof studentidlocal != "undefined" &&
      typeof parentemail != "undefined"
    ) {
      console.log("in the final area");
      updateemailindatabase();
    }
  }, [parentemail]);

  const onChanged1 = (text) => {
    setNewnumber3(text);
  };

  useEffect(() => {
    if (typeof parentphonenumberbefore != "undefined") {
      console.log(parentphonenumberbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)

         const safeParentPhoneNumber = Array.isArray(parentphonenumberbefore)
      ? parentphonenumberbefore
      : [parentphonenumberbefore];

      updateDoc(doc(firebase, "users", studentidlocal), {
        parentphonenumber: safeParentPhoneNumber,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }
  }, [parentphonenumberbefore]);

  useEffect(() => {
    if (typeof parentemailbefore != "undefined") {
      console.log(parentemailbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)

      const safeParentEmail = Array.isArray(parentemailbefore)
        ? parentemailbefore
        : [parentemailbefore];

      updateDoc(doc(firebase, "users", studentidlocal), {
        parentemail: safeParentEmail,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });
    }
  }, [parentemailbefore]);

  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setSid(selectedclass.profile.firebasestudentid)
    }
  }, [selectedclass]);

  useEffect(() => {

    console.log(studentid, "this is the id ");
    console.log(only2studentid, "this is the only2studentid");

  }, [studentid, only2studentid]);

  useEffect(() => {
    console.log(selectedclass);
    console.log(selectedclass1);
  }, [selectedclass, selectedclass1]);

  async function addthisnumber() {
    console.log("add a new nummber was runnd", parentphonenumber);

    let currenntarray = parentphonenumber;

    currenntarray.push(newnumber3);
    setParentphonenumber(currenntarray);
    setParentphonenumberbefore(currenntarray);
    setNewnumber3("");
  }

  async function addthisnumber2() {
    console.log("add a new nummber was runnd", parentemail);

    let currenntarray2 = parentemail;

    currenntarray2.push(newnumber3);

    setParentemail(currenntarray2);
    setParentemailbefore(currenntarray2);
    setNewnumber3("");
  }

  async function updatephonenumbberindatabase() {
    console.log("did it get  in to update?", parentphonenumber);

     const safeParentPhoneNumber = Array.isArray(parentphonenumber)
      ? parentphonenumber
      : [parentphonenumber];

    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentphonenumber: safeParentPhoneNumber,
    })
      .catch((error) => {
        console.log(error);
        alert(error);
      })
      .then(async (userRec) => {
        console.log("DOnneee");
        setParentphonenumberbefore();
      });
  }

  useEffect(() => {
    if (
      typeof googleclassroomid !== "undefined" &&
      Array.isArray(gc1datasent)
    ) {
      gc1datasent.forEach(item => {
        if (item.id === googleclassroomid) {
          setSelectedclass1(item);
          setGradeReceived(item.grade);
        }
      });
    }
  }, [googleclassroomid, gc1datasent]);

  async function updateemailindatabase() {
    console.log("did it get  in to update?", parentemail);


 const safeParentEmail = Array.isArray(parentemail)
      ? parentemail
      : [parentemail];

    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentemail: safeParentEmail,
    })
      .catch((error) => {
        console.log(error);
        alert(error);
      })
      .then(async (userRec) => {
        console.log("DOnneee");
        setParentemailbefore();
      });
  }

  async function deletethisnumber(value) {
    let temparray = [];
    parentphonenumber.forEach((element) => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentphonenumber(temparray);
  }

  async function deletethisemail(value) {
    let temparray = [];
    parentemail.forEach((element) => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentemail(temparray);
  }

  async function readonly() {
    alert("This page is 'Read Only' for Teachers.");
  }




  return (
    <>
      <div className="App22">
        <NavBar
          viewparentpage={isClassroomPage ? viewparentpage : null}
          setViewparentpage={isClassroomPage ? setViewparentpage : null}
          donotshow={isClassroomPage ? donotshow : null}
          bringinmenu2={isClassroomPage ? bringinmenu2 : null}
          role={isClassroomPage ? role : null}
        />

        {typeof viewparentpage != "undefined" && viewparentpage === false ? (

          <div className="App" style={{ maxWidth: newwidth }} onClick={() => setBringinmenu2(!bringinmenu2)}>
            <header className="App-header">

              <Classes
                gccompare={gccompare}
                getsyllabus={getsyllabus}
                gcdatasent={gcdatasent}
                gctimesent={gctimesent}
                gc1title={gc1title}
                gc1compare={gc1compare}
                gc1datasent={gc1datasent}
                gc1timesent={gc1timesent}
                gc1assignmentMaterials={gc1assignmentMaterials}
                setSelectedclass={setSelectedclass}
                sid={sid}
                only2studentid={only2studentid}
                studentid={studentid}
                setSid={setSid}
                selectedclass={selectedclass}
                selectedclass1={selectedclass1}
                setSelectedclass1={setSelectedclass1}
                setShowpersonal={setShowpersonal}
                showpersonal={showpersonal}
                gradereceived={gradereceived}
                nameinobject={nameinobject}
                googleclassroomid={googleclassroomid}
                averageofgradeswithzeros={averageofgradeswithzeros}
                averageofgrades={averageofgrades}
                lowscore={lowscore}
                highscore={highscore}
              />
            </header>
          </div>
        ) : language == "en" ? (
          <div className="App" style={{ maxWidth: newwidth }}>
            <header className="App-header">

              <Classes
                gccompare={gccompare}
                 getsyllabus={getsyllabus}
                gcdatasent={gcdatasent}
                gctimesent={gctimesent}
                gc1title={gc1title}
                gc1compare={gc1compare}
                gc1datasent={gc1datasent}
                gc1timesent={gc1timesent}
                gc1assignmentMaterials={gc1assignmentMaterials}
                setSelectedclass={setSelectedclass}
                sid={sid}
                only2studentid={only2studentid}
                studentid={studentid}
                setSid={setSid}
                selectedclass={selectedclass}
                selectedclass1={selectedclass1}
                setSelectedclass1={setSelectedclass1}
                setShowpersonal={setShowpersonal}
                showpersonal={showpersonal}
                gradereceived={gradereceived}
                nameinobject={nameinobject}
                googleclassroomid={googleclassroomid}
                averageofgradeswithzeros={averageofgradeswithzeros}
                averageofgrades={averageofgrades}
                lowscore={lowscore}
                highscore={highscore}

              />
            </header>
          </div>
        ) : (
          <div className="App" style={{ maxWidth: newwidth }}>
            <header className="App-header">

              <Classes
                gccompare={gccompare}
                 getsyllabus={getsyllabus}
                gcdatasent={gcdatasent}
                gctimesent={gctimesent}
                gc1title={gc1title}
                gc1compare={gc1compare}
                gc1datasent={gc1datasent}
                gc1timesent={gc1timesent}
                gc1assignmentMaterials={gc1assignmentMaterials}
                setSelectedclass={setSelectedclass}
                sid={sid}
                only2studentid={only2studentid}
                studentid={studentid}
                setSid={setSid}
                selectedclass={selectedclass}
                selectedclass1={selectedclass1}
                setSelectedclass1={setSelectedclass1}
                setShowpersonal={setShowpersonal}
                showpersonal={showpersonal}
                gradereceived={gradereceived}
                nameinobject={nameinobject}
                googleclassroomid={googleclassroomid}
                averageofgradeswithzeros={averageofgradeswithzeros}
                averageofgrades={averageofgrades}
                lowscore={lowscore}
                highscore={highscore}
              />
            </header>
          </div>
        )}
      </div>
      <ReactTooltip
        id="my-tooltip-1"
        place="right"
        content="Add New Bulletin Item"
        isOpen={isOpen1}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-2"
        place="right"
        content="Press To Save And View Entry"
        isOpen={isOpen2}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-3"
        place="right"
        content="Press To Edit Section"
        isOpen={isOpen3}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-3b"
        place="right"
        content="Press To Edit Section"
        isOpen={isOpen3b}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-5"
        place="right"
        content="Press To Save & View Section"
        isOpen={isOpen5}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-5b"
        place="right"
        content="Press To Save & View Section"
        isOpen={isOpen5b}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-4"
        place="right"
        content="Press To Edit Entry"
        isOpen={isOpen4}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-6"
        place="right"
        content="Press To Save & View Section"
        isOpen={isOpen6}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-8"
        place="right"
        content="Students Can Not Submit Photo Descriptions Of This Class"
        isOpen={isOpen8}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-9"
        place="right"
        content="Students Can Submit Photo Descriptions Of This Class"
        isOpen={isOpen9}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-10"
        place="bottom-start"
        content="Students can NOT submit Photo Descriptions of you (the teacher)"
        isOpen={isOpen10}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-11"
        place="bottom-start"
        content="Students can submit Photo Descriptions of you (the teacher)"
        isOpen={isOpen11}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-12"
        place="right"
        content="Show This Section's Teacher Submitted Photo To Parents"
        isOpen={isOpen12}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-13"
        place="bottom-end"
        content="Approved Student Photos Will Only Be Presented To Their Own Parents"
        isOpen={isOpen13}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-14"
        place="bottom-start"
        content="Approved Student Photos Will Be Presented To All Parents"
        isOpen={isOpen14}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-15"
        place="right"
        content="Show This Section's Teacher Submitted Photo To Parents"
        isOpen={isOpen15}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-16"
        place="right"
        content="Approved Student Photos Will Only Be Presented To Their Own Parents"
        isOpen={isOpen16}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-17"
        place="bottom-start"
        content="Approved Student Photos Will Be Presented To All Parents"
        isOpen={isOpen17}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-18"
        place="bottom-start"
        content="This Bulletin Entry Will Be Seen By Parents"
        isOpen={isOpen18}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-19"
        place="bottom-start"
        content="This Bulletin Entry Will NOT Be Seen By Parents"
        isOpen={isOpen19}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-20"
        place="right"
        content="This Teacher Section Will Be Seen By Parents"
        isOpen={isOpen20}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-21"
        place="bottom-start"
        content="This Teacher Section Will NOT Be Seen By Parents"
        isOpen={isOpen21}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-22"
        place="right"
        content="This Class Section Will Be Seen By Parents"
        isOpen={isOpen22}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-23"
        place="bottom-start"
        content="This Class Section Will NOT Be Seen By Parents"
        isOpen={isOpen23}
        style={{ color: "orange", fontSize: "25px" }}
      />
      <ReactTooltip
        id="my-tooltip-24"
        place="bottom-start"
        content="Permanently Delete Entry"
        isOpen={isOpen24}
        style={{ color: "orange", fontSize: "25px" }}
      />

      <ReactTooltip
        id="my-tooltip-25"
        place="bottom-start"
        content="Add To All Of My Classes"
        isOpen={isOpen25}
        style={{ color: "orange", fontSize: "25px" }}
      />
    </>
  );
}

export default App;